import React from 'react';
import InlineSVG from 'svg-inline-react';

import xMark from '../../assets/images/x-mark.svg';

export default () => (
    <div className='dashboard-dropdown-item'>
        <div className='dashboard-dropdown-label'>
            <InlineSVG className='dashboard-dropdown-legend-x-mark-icon' src={xMark} />
            <div className='dashboard-dropdown-legend-text'>= Number of times form was used</div>
        </div>
    </div>
);
